import { toISODate } from "../../utils/date";

/**
 * Valores iniciais do formulário de Mídia.
 */
export const mediaDefaults = {
    name: "",
    type: "single",          // "single" = imagem única | "carousel" = carrossel de imagens
    imageUrl: null,           // Usada quando type === "single"
    carouselImages: [],       // Usada quando type === "carousel" — array de { url, order }
    slideDuration: 8,         // Segundos por slide no carrossel (padrão 8s)
    startDate: toISODate(new Date()),
    endDate: "",
    status: "active",
};
